/* import __COLOCATED_TEMPLATE__ from './cancellation-success.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();